var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$route.query.verification_code)?_c('div',{staticClass:"position-fixed",staticStyle:{"bottom":"50%","margin-bottom":"-5rem","right":"50%","margin-right":"-5rem"}},[_c('AppSpinner',{staticClass:"text-secondary",attrs:{"size":"10"}}),_c('vue-snotify')],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }